import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import card1 from '../assets/images/Collection/artwork-1.png';
import card2 from '../assets/images/Collection/artwork-2.png';
import card3 from '../assets/images/Collection/artwork-3.png';
import artistPic from '../assets/images/Collection/artist-picture.png';
import Header from './Header';


class Collection extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}
                <div className="container-fluid">
                    <Link to="/Collection">
                        <div className="row header justify-content-center">
                            <div className="header-text col-lg-7 col-sm-12">
                            </div>
                            <div className="col-lg-4 col-sm-10 artist text-center">
                                <span>Artist Name</span>
                                <h6>Collection Title</h6>
                                <h1>March 19</h1>
                                <p>1:30 PM EST Drawings</p>
                                <p>2:30 PM EST Open Editions</p>
                            </div>
                        </div>
                    </Link>
                </div>
                {/* Hero slider end */}

                {/* Collection content area start */}
                <div className="container margin-70 text-center collection-content">
                    <div className="row justify-content-center">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                            <h3>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</h3>
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>
                            <h3>Collection opens in 5 hours 4 minutes and 3 seconds</h3>
                        </div>
                        <div className="col-lg-2"></div>
                        <div className="card text-left">
                            <Link to="/FutureCollection">
                                <img src={card1} className="card-img-top" alt="" />
                            </Link>
                            <Link to="/FutureCollection">
                                <div className="card-body">
                                    <h3>Collection Title</h3>
                                    <strong>Artist Name</strong>
                                    <h6 className="card-text"><small>5 Exibitions</small></h6>
                                </div>
                            </Link>
                        </div>
                        <div className="card text-left">
                            <Link to="/FutureCollection">
                                <img src={card2} className="card-img-top" alt="" />
                            </Link>
                            <Link to="/FutureCollection">
                                <div className="card-body">
                                    <h3>Collection Title</h3>
                                    <strong>Artist Name</strong>
                                    <h6 className="card-text"><small>5 Exibitions</small></h6>
                                </div>
                            </Link>
                        </div>
                        <div className="card text-left">
                            <Link to="/FutureCollection">
                                <img src={card3} className="card-img-top" alt="" />
                            </Link>
                            <Link to="/FutureCollection">
                                <div className="card-body">
                                    <h3>Collection Title</h3>
                                    <strong>Artist Name</strong>
                                    <h6 className="card-text"><small>5 Exibitions</small></h6>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                {/* Collection content area end */}

                {/* why we love  art vader area start */}
                <div className="container text-center mb-5 collection-content">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <h3>Why We Love Art Vader</h3>
                            <Link to="/UserProfileArtist"><img src={artistPic} alt="artistPic" className="collection-artist-pic" /></Link>
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>
                            <h3>Follow Art Vader to receive exclusive release info</h3>
                            <button>Follow</button>
                            <h3>Learn More about Duke Dumont</h3>
                            <h6><Link to="#">https://website.com</Link></h6>
                            <h6><Link to="#">https://socialmedia.com</Link></h6>
                        </div>
                    </div>
                </div>
                {/* why we love  art vader area end */}
            </div>
        )
    }
};

export default Collection;